var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{attrs:{"autocomplete":"off"},on:{"submit":function($event){$event.preventDefault();return _vm.deleteDocuments.apply(null, arguments)}}},[_c('el-button',{attrs:{"type":"primary","native-type":"submit","loading":_vm.loading_submit}},[_vm._v("Eliminar documentos de prueba")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }